// extracted by mini-css-extract-plugin
export default {"max-w-span":"link_max-w-span__PPAcr","min-w-span":"link_min-w-span__4i8qv","min-w-img":"link_min-w-img__KYSZ2","h-40px":"link_h-40px__2a-mC","link-image":"link_link-image__c6eJP"};